<template>
  <div>
    <div class="card card-info">
      <div class="card-header pt-2 pb-2">
        <a
          data-toggle="collapse"
          href="#sitios"
          aria-expanded="true"
          id="heading-sitios"
          class="d-block"
        >
          <i class="fa fa-chevron-down pull-right"></i>
          Sitios
        </a>
      </div>
      <div id="sitios" class="collapse show">
        <div class="card-body">
          <div class="row">
            <div class="col-md-10">
              <v-select
                :class="[
                  $v.sitio.id.$invalid ? 'is-invalid' : 'is-valid',
                  $store.getters.getDarkMode ? 'dark-vselect' : '',
                ]"
                v-model="sitio"
                placeholder="Buscar sitios"
                label="nombre"
                class="form-control form-control-sm p-0"
                :options="sitios"
                :filterable="false"
                @search="buscarSitios"
                @input="selectSitio()"
              >
                <template #option="option">
                  <div>
                    <strong>{{ option.nombre }}</strong>
                    <small v-if="option.codigo"> ({{ option.codigo }})</small>
                    <br />
                    <small v-if="option.ciudad">
                      {{ option.ciudad.nombre }}
                      <span v-if="option.departamento">
                        - {{ option.departamento.nombre }}
                      </span>
                    </small>
                  </div>
                </template>
              </v-select>
            </div>
            <div class="col-md-2">
              <button
                class="btn btn-sm btn-info"
                v-show="!$v.sitio.$invalid"
                @click="agregarSitio()"
              >
                <i class="fas fa-plus"></i> Agregar
              </button>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-md-12">
              <div v-if="list_sitios.length === 0" class="alert alert-info">
                <i class="fas fa-info-circle"></i> No hay sitios asignados a
                este usuario. Los sitios asignados actuarán como filtro en la
                Central de Tráfico.
              </div>
              <table
                v-else
                class="table table-striped table-hover table-head-fixed text-nowrap table-sm"
              >
                <thead>
                  <tr>
                    <th>Código</th>
                    <th>Nombre</th>
                    <th>Ciudad</th>
                    <th>Departamento</th>
                    <th>Acción</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in list_sitios" :key="item.id">
                    <td>{{ item.codigo }}</td>
                    <td>{{ item.nombre }}</td>
                    <td>{{ item.ciudad ? item.ciudad.nombre : "-" }}</td>
                    <td>
                      {{ item.departamento ? item.departamento.nombre : "-" }}
                    </td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-sm btn-danger"
                        @click="eliminarSitio(item.id)"
                      >
                        <i class="fas fa-trash-alt"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import axios from "axios";
import { required } from "vuelidate/lib/validators";

export default {
  name: "UsuarioSitio",
  components: {
    vSelect,
  },
  props: {
    userId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      sitios: [],
      list_sitios: [],
      sitio: {},
      sitios_ids: [],
    };
  },
  validations: {
    sitio: {
      id: {
        required,
      },
    },
  },
  methods: {
    index() {
      if (!this.userId) {
        return;
      }
      axios
        .get("/api/admin/usuarios/sitios/" + this.userId)
        .then((response) => {
          if (response.data.success) {
            this.list_sitios = response.data.sitios;
            this.sitios_ids = this.list_sitios.map((s) => s.id);
          }
        })
        .catch((error) => {
          console.error("Error al cargar sitios:", error);
        });
    },

    buscarSitios(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "/api/admin/sitios/lista?nombre=" + search;
        axios
          .get(url)
          .then(function (response) {
            me.sitios = response.data;
            loading(false);
          })
          .catch(function (error) {
            loading(false);
            me.$swal({
              icon: "error",
              title: "Ocurrió un error al buscar sitios: " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    selectSitio() {
      // Validar que no esté ya en la lista
      if (this.sitios_ids.includes(this.sitio.id)) {
        this.$swal({
          icon: "warning",
          title: "Este sitio ya está asignado al usuario.",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        this.sitio = {};
        return false;
      }
    },

    agregarSitio() {
      if (!this.sitio.id) return;

      // Validar duplicados
      if (this.sitios_ids.includes(this.sitio.id)) {
        this.$swal({
          icon: "warning",
          title: "Este sitio ya está asignado al usuario.",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return false;
      }

      // Agregar a la lista temporal
      this.sitios_ids.push(this.sitio.id);

      // Guardar en el backend
      this.guardarSitios();

      // Limpiar selección
      this.sitio = {};
    },

    eliminarSitio(sitioId) {
      this.$swal({
        title: "¿Está seguro?",
        text: "Se eliminará la asignación de este sitio al usuario",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          // Eliminar del array
          this.sitios_ids = this.sitios_ids.filter((id) => id !== sitioId);

          // Guardar cambios
          this.guardarSitios();
        }
      });
    },

    guardarSitios() {
      axios
        .put("/api/admin/usuarios/sitios/" + this.userId, {
          sitios_ids: this.sitios_ids,
        })
        .then((response) => {
          if (response.data.success) {
            this.index();
            this.$swal({
              icon: "success",
              title: response.data.message,
              toast: true,
              position: "bottom-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          }
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: "Error al guardar sitios: " + error.message,
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
        });
    },
  },
  mounted() {
    this.index();
  },
  watch: {
    userId(newId, oldId) {
      if (newId && newId !== oldId) {
        this.index();
      }
    },
  },
};
</script>
